var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 10.0007C3.33333 9.54041 3.70643 9.16732 4.16667 9.16732H10.8333C11.2936 9.16732 11.6667 9.54041 11.6667 10.0007C11.6667 10.4609 11.2936 10.834 10.8333 10.834H4.16667C3.70643 10.834 3.33333 10.4609 3.33333 10.0007Z",
    fill: "#667185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 13.334C3.70643 13.334 3.33333 13.7071 3.33333 14.1673C3.33333 14.6276 3.70643 15.0006 4.16667 15.0006H10.8333C11.2936 15.0006 11.6667 14.6276 11.6667 14.1673C11.6667 13.7071 11.2936 13.334 10.8333 13.334H4.16667Z",
    fill: "#667185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0.833984C1.49238 0.833984 0 2.32637 0 4.16732V15.834C0 17.6749 1.49238 19.1673 3.33333 19.1673H11.6667C13.5076 19.1673 15 17.6749 15 15.834V7.57244C15 6.79265 14.7266 6.03754 14.2274 5.43849L11.3898 2.03337C10.7565 1.27339 9.81833 0.833984 8.82906 0.833984H3.33333ZM1.66667 4.16732C1.66667 3.24684 2.41286 2.50065 3.33333 2.50065H8.33333V5.00065C8.33333 6.8416 9.82572 8.33398 11.6667 8.33398H13.3333V15.834C13.3333 16.7545 12.5871 17.5006 11.6667 17.5006H3.33333C2.41286 17.5006 1.66667 16.7545 1.66667 15.834V4.16732ZM13.0661 6.66732C13.0299 6.61127 12.9901 6.5572 12.947 6.50547L10.1094 3.10034C10.0747 3.0587 10.0382 3.01898 10 2.98127V5.00065C10 5.92112 10.7462 6.66732 11.6667 6.66732H13.0661Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPage);
export default __webpack_public_path__ + "static/media/history_page.8c79c085374d6c00dfe780eff42c6fa9.svg";
export { ForwardRef as ReactComponent };